module.exports = __webpack_public_path__ + "static/media/external_icon.8f9fa429.svg";